module.exports = __webpack_public_path__ + "static/media/snowman.2051eb77.svg";